import type { en } from './en'

/** Vietnamese catalog. Typed against `en` so a missing key is a compile error. */
export const vi: Record<keyof typeof en, string> = {
  'ui.dashboard': 'Tổng quan',
  'ui.openMenu': 'Mở menu',
  'ui.closeMenu': 'Đóng menu',
  'ui.signOut': 'Đăng xuất',
  'ui.language': 'Ngôn ngữ',
  'ui.signedInAs': 'Đăng nhập với tên {name}',
  'ui.more': 'Bản ghi liên quan',
  'ui.cancel': 'Huỷ',
  'ui.back': 'Quay lại',
  'ui.create': 'Tạo',
  'ui.save': 'Lưu thay đổi',
  'ui.saving': 'Đang lưu…',
  'ui.saved': 'Đã lưu thay đổi.',
  'ui.delete': 'Xoá',
  'ui.edit': 'Sửa {name}',
  'ui.actions': 'Thao tác',
  'ui.new': 'Thêm {name}',
  'ui.records': '{count} bản ghi',
  'ui.search': 'Tìm kiếm',
  'ui.searchBy': 'Tìm theo {field}',
  'ui.filterBy': 'Lọc theo {field}',
  'ui.allOf': 'Tất cả {field}',
  'ui.clear': 'Xoá lọc',
  'ui.showAll': 'Xem tất cả',
  'ui.showing': 'Đang xem',
  'ui.viewAll': 'Xem tất cả',
  'ui.previous': 'Trước',
  'ui.next': 'Sau',
  'ui.pageOf': 'Trang {page}/{total}',
  'ui.pagination': 'Phân trang',
  'ui.loading': 'Đang tải…',
  'ui.select': '— Chọn —',
  'ui.none': '— Không —',
  'ui.yes': 'Có',
  'ui.no': 'Không',
  'ui.readOnly': 'Chỉ đọc',
  'ui.requiredHint': 'Các trường có dấu * là bắt buộc.',
  'ui.details': 'Chi tiết',
  'ui.addRow': 'Thêm dòng',
  'ui.removeRow': 'Xoá dòng {n} của {field}',
  'ui.longitude': 'Kinh độ',
  'ui.latitude': 'Vĩ độ',
  'ui.optionsError': 'Không tải được danh sách lựa chọn cho trường này.',
  'ui.noMatches': 'Không có bản ghi phù hợp',
  'ui.noMatchesHint': 'Thử từ khoá hoặc bộ lọc khác.',
  'ui.noneYet': 'Chưa có {name}',
  'ui.loadError': 'Không tải được dữ liệu',
  'ui.deleteTitle': 'Xoá bản ghi?',
  'ui.deleteBody': '"{name}" sẽ bị xoá vĩnh viễn và không thể khôi phục.',
  'ui.confirm': 'Xác nhận',
  'ui.working': 'Đang xử lý…',
  'ui.deleteAria': 'Xoá {name}',
  'ui.signIn': 'Đăng nhập',
  'ui.signingIn': 'Đang đăng nhập…',
  'ui.signInHint': 'Dùng tài khoản Wareflex của bạn.',
  'ui.email': 'Email',
  'ui.password': 'Mật khẩu',
  'ui.loginTitle': 'Vận hành logistics trên một nền tảng.',
  'ui.loginBody': 'Theo dõi lô hàng, quản lý đối tác và bảng giá, giữ tài chính luôn khớp.',
  'ui.passwordMin': 'Tối thiểu 8 ký tự.',
  'ui.passwordKeep': 'Để trống nếu giữ nguyên mật khẩu hiện tại.',
  'ui.attention': 'Cần xử lý',
  'ui.allClear': 'Hiện không có gì trễ hạn hoặc bị kẹt.',
  'ui.recentShipments': 'Lô hàng gần đây',
  'ui.byStatus': 'Lô hàng theo trạng thái',
  'ui.noShipmentsYet': 'Chưa có lô hàng',
  'ui.noShipmentsHint': 'Tạo lô hàng đầu tiên để bắt đầu theo dõi vận hành.',
  'view.overdue-pickup': 'Trễ lấy hàng',
  'view.overdue-pickup.hint': 'Đã quá hạn lấy hàng yêu cầu nhưng lô hàng chưa được lấy',
  'view.overdue-delivery': 'Trễ giao hàng',
  'view.overdue-delivery.hint': 'Quá ngày hoàn thành dự kiến và vẫn đang mở',
  'view.exceptions': 'Ngoại lệ',
  'view.exceptions.hint': 'Tạm dừng, chậm trễ, kiểm hải quan hoặc hoàn tất có vấn đề',
  'view.unbooked': 'Chờ booking',
  'view.unbooked.hint': 'Nháp hoặc mới tạo đơn, chưa xác nhận',
  'view.active': 'Đang thực hiện',
  'view.open': 'Hoá đơn chưa thanh toán',
  'view.open.hint': 'Nháp, đã phát hành hoặc thanh toán một phần',
  'sec.booking': 'Booking',
  'sec.schedule': 'Lịch trình',
  'sec.notes': 'Ghi chú',
  'sec.invoice': 'Hoá đơn',
  'sec.parties': 'Các bên',
  'sec.billing': 'Thanh toán',
  'sec.identity': 'Định danh',
  'sec.contact': 'Liên hệ',
  'sec.equipment': 'Thiết bị',
  'sec.vehicle': 'Xe và tài xế',
  'sec.cargo': 'Hàng hoá',
  'sec.stop': 'Điểm dừng',
  'sec.more': 'Thông tin khác',
  'sec.details': 'Chi tiết',
  'ui.childAdd': 'Thêm {name}',
  'ui.childEdit': 'Sửa {name}',
  'ui.childNew': 'Thêm {name}',
  'ui.childEmpty': 'Chưa có {name}.',
  'ui.childRemove': 'Bỏ {name}',
  'ui.childRows': '{count} sẽ được tạo',
  'ui.childSaveFirst': 'Lưu cùng bản ghi chính. Nếu có lỗi, sẽ không tạo gì cả.',
  'ui.childRowTitle': '{name} {n}',
  'ui.childOpen': 'Mở',
  'ui.childSystem': 'Tự ghi nhận khi trạng thái thay đổi.',
  'ui.childError': 'Hãy sửa các trường được đánh dấu trong {name}.',
  'ui.unsaved': 'Có thay đổi chưa lưu',
  'ui.tabOverview': 'Tổng quan',
  'ui.addRelated': 'Thêm {name}',
  'ui.relatedEmpty': 'Chưa có {name}.',
  'ui.relatedOpenAll': 'Mở trong danh sách',
  'err.permission': 'Bạn không có quyền thực hiện thao tác này.',
  'err.notFound': 'Không tìm thấy bản ghi.',
  'err.fixFields': 'Vui lòng sửa các trường được đánh dấu.',
  'err.unexpected': 'Lỗi không mong muốn',
  'err.referenced': 'Bản ghi này đang được dữ liệu khác tham chiếu nên không thể xoá.',
  'err.loginFailed': 'Đăng nhập thất bại.',
  'err.badCredentials': 'Email hoặc mật khẩu không đúng.',
  'err.locked': 'Tài khoản tạm khoá do nhập sai quá nhiều lần. Vui lòng thử lại sau.',
  'err.signInRetry': 'Không thể đăng nhập. Vui lòng thử lại.',
  'err.number': 'Nhập một số hợp lệ',
  'err.point': 'Nhập cả kinh độ và vĩ độ',
  'grp.Operations': 'Vận hành',
  'grp.Finance': 'Tài chính',
  'grp.Pricing': 'Bảng giá',
  'grp.Master Data': 'Danh mục',
  'grp.System': 'Hệ thống',
  'grp.Other': 'Khác',
  'col.users': 'Người dùng',
  'col.users.plural': 'Người dùng',
  'col.organizations': 'Tổ chức',
  'col.organizations.plural': 'Tổ chức',
  'col.locations': 'Địa điểm',
  'col.locations.plural': 'Địa điểm',
  'col.shipments': 'Lô hàng',
  'col.shipments.plural': 'Lô hàng',
  'col.shipment-stops': 'Điểm dừng',
  'col.shipment-stops.plural': 'Điểm dừng',
  'col.shipment-units': 'Đơn vị vận chuyển',
  'col.shipment-units.plural': 'Đơn vị vận chuyển',
  'col.shipment-events': 'Sự kiện',
  'col.shipment-events.plural': 'Sự kiện',
  'col.shipment-charges': 'Khoản phí',
  'col.shipment-charges.plural': 'Khoản phí',
  'col.invoices': 'Hoá đơn',
  'col.invoices.plural': 'Hoá đơn',
  'col.shipment-documents': 'Chứng từ',
  'col.shipment-documents.plural': 'Chứng từ',
  'col.rate-cards': 'Bảng giá',
  'col.rate-cards.plural': 'Bảng giá',
  'col.rate-card-lines': 'Dòng bảng giá',
  'col.rate-card-lines.plural': 'Dòng bảng giá',
  'field.active': 'Đang hoạt động',
  'field.actualAt': 'Thời gian thực tế',
  'field.actualCompleteAt': 'Hoàn thành thực tế',
  'field.address': 'Địa chỉ',
  'field.aliases': 'Tên gọi khác',
  'field.amountExVat': 'Thành tiền (chưa VAT)',
  'field.apTotal': 'Tổng phải trả',
  'field.arTotal': 'Tổng phải thu',
  'field.billingPeriod': 'Kỳ thanh toán',
  'field.bookingDate': 'Ngày booking',
  'field.bookingLine': 'Hãng tàu/Hãng bay',
  'field.bookingNo': 'Số booking',
  'field.buyer': 'Người mua',
  'field.cargoStuffingPlace': 'Nơi đóng hàng',
  'field.cargoType': 'Loại hàng',
  'field.category': 'Phân loại',
  'field.cbm': 'Thể tích (CBM)',
  'field.charges': 'Khoản phí',
  'field.client': 'Khách hàng',
  'field.cargo_id': 'Cargo Id',
  'field.cargo_payload_max': 'Cargo Payload Max',
  'field.cargo_payload_min': 'Cargo Payload Min',
  'field.cargo_type': 'Cargo Type',
  'field.credit_term': 'Credit Term',
  'field.mm': 'Mm',
  'field.month': 'Month',
  'field.transport_type_long': 'Loại vận chuyển (dài)',
  'field.transport_type_short': 'Loại vận chuyển (ngắn)',
  'field.truck_fee_name': 'Tên phí xe',
  'field.truck_fee_code': 'Truck Fee Code',
  'field.truck_fee_name_vn': 'Truck Fee Name Vn',
  'field.truck_fee_type': 'Truck Fee Type',
  'field.truck_size': 'Truck Size',
  'field.year': 'Year',
  'field.code': 'Mã',
  'field.contact': 'Liên hệ',
  'field.contacts': 'Danh sách liên hệ',
  'field.containerNo': 'Số container',
  'field.containerOwner': 'Chủ container',
  'field.coordinates': 'Toạ độ',
  'field.createdAt': 'Ngày tạo',
  'field.createdBy': 'Người tạo',
  'field.creditTerm': 'Điều khoản công nợ',
  'field.currency': 'Tiền tệ',
  'field.customsDeclarationNo': 'Số tờ khai hải quan',
  'field.dangerous': 'Hàng nguy hiểm',
  'field.dangerous_class': 'Nhóm hàng nguy hiểm',
  'field.days': 'Số ngày',
  'field.defaultCreditTerm': 'Điều khoản công nợ mặc định',
  'field.destination': 'Điểm đến',
  'field.direction': 'Chiều',
  'field.document': 'Tệp chứng từ',
  'field.documentDate': 'Ngày chứng từ',
  'field.documents': 'Chứng từ',
  'field.driverLicense': 'Bằng lái',
  'field.driverName': 'Tài xế',
  'field.driverPhone': 'SĐT tài xế',
  'field.email': 'Email',
  'field.equipmentType': 'Loại thiết bị',
  'field.estimatedCompleteAt': 'Hoàn thành dự kiến',
  'field.events': 'Sự kiện',
  'field.expiresAt': 'Hết hạn',
  'field.exportCode': 'Mã xuất',
  'field.fee_type': 'Loại phí',
  'field.file': 'Tệp',
  'field.financialSummary': 'Tóm tắt tài chính',
  'field.googleMapURL': 'Liên kết Google Maps',
  'field.happenedAt': 'Thời điểm xảy ra',
  'field.incoterm': 'Incoterm',
  'field.instructions': 'Hướng dẫn',
  'field.invoice': 'Hoá đơn',
  'field.invoiceDate': 'Ngày hoá đơn',
  'field.invoiceNumber': 'Số hoá đơn',
  'field.invoices': 'Hoá đơn',
  'field.issuer': 'Bên phát hành',
  'field.legalName': 'Tên pháp lý',
  'field.lines': 'Dòng chi tiết',
  'field.location': 'Địa điểm',
  'field.locations': 'Địa điểm',
  'field.mainPartner': 'Đối tác chính',
  'field.margin': 'Lợi nhuận gộp',
  'field.mode': 'Phương thức',
  'field.name': 'Tên',
  'field.name_vi': 'Tên tiếng Việt',
  'field.note': 'Ghi chú',
  'field.notes': 'Ghi chú',
  'field.number': 'Số',
  'field.organization': 'Tổ chức',
  'field.origin': 'Điểm đi',
  'field.owner': 'Chủ sở hữu',
  'field.payload_max': 'Tải trọng tối đa',
  'field.payload_min': 'Tải trọng tối thiểu',
  'field.phone': 'Điện thoại',
  'field.plannedAt': 'Thời gian kế hoạch',
  'field.quantity': 'Số lượng',
  'field.rate': 'Đơn giá',
  'field.rateCard': 'Bảng giá',
  'field.recipient': 'Bên nhận',
  'field.remarks': 'Ghi chú',
  'field.requestedPickupAt': 'Lấy hàng yêu cầu',
  'field.restrictions': 'Hạn chế',
  'field.roles': 'Vai trò',
  'field.sealNo': 'Số seal',
  'field.seller': 'Người bán',
  'field.sequence': 'Thứ tự',
  'field.serviceFeeType': 'Loại phí dịch vụ',
  'field.serviced': 'Có phục vụ',
  'field.shipment': 'Lô hàng',
  'field.shipmentId': 'Mã lô hàng',
  'field.shortName': 'Tên ngắn',
  'field.size': 'Kích cỡ',
  'field.source': 'Nguồn',
  'field.sourceDocument': 'Chứng từ gốc',
  'field.status': 'Trạng thái',
  'field.stops': 'Điểm dừng',
  'field.subtotal': 'Tạm tính',
  'field.taxId': 'Mã số thuế',
  'field.total': 'Tổng cộng',
  'field.totalAmount': 'Tổng tiền',
  'field.totals': 'Tổng hợp',
  'field.transportType': 'Loại vận chuyển',
  'field.trigger': 'Tính từ ngày',
  'field.type': 'Loại',
  'field.units': 'Đơn vị vận chuyển',
  'field.validFrom': 'Hiệu lực từ',
  'field.validUntil': 'Hiệu lực đến',
  'field.value': 'Giá trị',
  'field.vatAmount': 'Tiền VAT',
  'field.vatRate': 'Thuế suất VAT',
  'field.vatTotal': 'Tổng VAT',
  'field.vehicleNo': 'Biển số xe',
  'field.wareflexNote': 'Ghi chú nội bộ',
  'field.weightKg': 'Trọng lượng (kg)',
  'field.password': 'Mật khẩu',
  'opt.CFR': 'CFR',
  'opt.CIF': 'CIF',
  'opt.CIP': 'CIP',
  'opt.DAP': 'DAP',
  'opt.DDP': 'DDP',
  'opt.DPU': 'DPU',
  'opt.EXW': 'EXW',
  'opt.FCA': 'FCA',
  'opt.FOB': 'FOB',
  'opt.accounting': 'Kế toán',
  'opt.active': 'Đang hoạt động',
  'opt.admin': 'Quản trị viên',
  'opt.air': 'Hàng không',
  'opt.bol': 'Vận đơn',
  'opt.booking': 'Booking',
  'opt.booking-confirmed': 'Đã xác nhận booking',
  'opt.booking-date': 'Ngày booking',
  'opt.cancelled': 'Đã huỷ',
  'opt.carrier': 'Nhà vận tải',
  'opt.charge': 'Khoản phí',
  'opt.client': 'Khách hàng',
  'opt.closed': 'Đã đóng',
  'opt.completed-with-issue': 'Hoàn tất có vấn đề',
  'opt.container-drop': 'Trả container',
  'opt.container-pickup': 'Lấy container',
  'opt.customer': 'Khách hàng',
  'opt.customs': 'Hải quan',
  'opt.customs-inspection': 'Kiểm hải quan',
  'opt.delayed': 'Chậm trễ',
  'opt.delivered': 'Đã giao',
  'opt.delivery': 'Giao hàng',
  'opt.delivery-date': 'Ngày giao hàng',
  'opt.delivery-receipt': 'Biên nhận giao hàng',
  'opt.depot': 'Bãi container',
  'opt.draft': 'Nháp',
  'opt.expected': 'Dự kiến',
  'opt.expired': 'Hết hạn',
  'opt.factory': 'Nhà máy',
  'opt.freight': 'Cước vận chuyển',
  'opt.import': 'Nhập khẩu',
  'opt.in-transit': 'Đang vận chuyển',
  'opt.inactive': 'Ngừng hoạt động',
  'opt.invoice': 'Hoá đơn',
  'opt.invoice-date': 'Ngày hoá đơn',
  'opt.issued': 'Đã phát hành',
  'opt.management': 'Quản lý',
  'opt.manual': 'Thủ công',
  'opt.multimodal': 'Đa phương thức',
  'opt.office': 'Văn phòng',
  'opt.on-hold': 'Tạm dừng',
  'opt.onboarding': 'Đang tiếp nhận',
  'opt.operations': 'Vận hành',
  'opt.order-created': 'Đã tạo đơn',
  'opt.other': 'Khác',
  'opt.paid': 'Đã thanh toán',
  'opt.partially-paid': 'Thanh toán một phần',
  'opt.partner': 'Đối tác',
  'opt.payable': 'Phải trả',
  'opt.picked-up': 'Đã lấy hàng',
  'opt.pickup': 'Lấy hàng',
  'opt.pickup-scheduled': 'Đã lên lịch lấy hàng',
  'opt.pod': 'Chứng từ giao nhận (POD)',
  'opt.port': 'Cảng',
  'opt.pricing': 'Bảng giá',
  'opt.receivable': 'Phải thu',
  'opt.received': 'Đã nhận',
  'opt.rejected': 'Bị từ chối',
  'opt.sea': 'Đường biển',
  'opt.surcharge': 'Phụ phí',
  'opt.system': 'Hệ thống',
  'opt.truck': 'Đường bộ',
  'opt.verified': 'Đã xác minh',
  'opt.void': 'Đã huỷ bỏ',
  'opt.wareflex': 'Wareflex',
  'opt.warehouse': 'Kho',
  'desc.billingPeriod': 'Định dạng YYYY_MM, ví dụ 2026_05',
  'desc.organization': 'Bắt buộc với người dùng cổng khách hàng và đối tác.',
}
